export default "__VITE_ASSET__Cw2XzK6v__"